import CheckoutContainer from './CheckoutContainer';

export default CheckoutContainer;
